
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './logic/login/reducer';
import businessReducer from './logic/business/reducer';
import categoriesReducer from './logic/categories/reducer';
import planReducer from './logic/plans/reducer';
import templateReducer from './logic/customTemplates/reducer';
import timingReducer from './logic/timings/reducer';
import dateReducer from './logic/dates/reducer';
import errorReducer from './logic/error/reducer';
import leadReducer from './logic/leads/reducer';
import profileReducer from './logic/profile/reducer';
import accountReducer from './logic/accounts/reducer';
import reportReducer from './logic/reports/reducer';
const store = configureStore({
    reducer: {
        auth: authReducer,
        business: businessReducer,
        categories: categoriesReducer,
        plans:planReducer,
        template:templateReducer,
        timings:timingReducer,
        date:dateReducer,
        error:errorReducer,
        leads:leadReducer,
        profile:profileReducer,
        account:accountReducer,
        reports:reportReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['date/setSelectedDate'],
                ignoredActionPaths: ['payload'],
                ignoredPaths: ['date.selectedDate', 'date.dates', 'date.datesMobile'],
            },
        }),
})

export default store;
